<!-- =========================================================================================
    File Name: TableMiscellaneous.vue
    Description: Combine filter,sorter, pagination etc.
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card title="Order" id="account-manage-buttons">
    <div>
      <div v-if="orders.length == 0">
        <br />
        <h5>Load data ....</h5>
      </div>
      <vs-table
        v-model="selected"
        stripe
        :data="orders"
        id="button-with-loading"
        v-else
      >
        <template slot="thead">
          <vs-th sort-key="title">Code Number</vs-th>
          <vs-th sort-key="title">Promo Code</vs-th>
          <vs-th sort-key="description">Price</vs-th>

          <vs-th sort-key="requirement">Status</vs-th>
          <vs-th sort-key="title">Detail</vs-th>
          <vs-th sort-key="title">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.order_number }}</vs-td>
            <vs-td>{{ tr.promo_code }}</vs-td>
            <vs-td>{{ tr.price }}</vs-td>

            <vs-td>{{ setStatus(tr.status) }}</vs-td>
            <vs-td
              ><vs-button
                @click="setPopUp(tr)"
                color="primary"
                icon-pack="feather"
                icon="icon-search"
              ></vs-button
            ></vs-td>
            <vs-td
              :data="tr.status"
              v-if="tr.status != 4 && tr.status != 9 && tr.transaction != null"
            >
              <vs-dropdown
                vs-trigger-click
                class="ml-auto md:block hidden cursor-pointer"
              >
                <vs-button icon="icon-settings" icon-pack="feather"></vs-button>
                <vs-dropdown-menu class="w-32">
                  <vs-dropdown-item v-if="tr.transaction.status < 2">
                    <div
                      @click="verifyOrder(tr.transaction.id)"
                      class="flex items-center"
                    >
                      <span>Verify</span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="tr.transaction.status < 3">
                    <div
                      @click="unverifyOrder(tr.transaction.id)"
                      class="flex items-center"
                    >
                      <span>Unverify</span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="tr.status < 4">
                    <div @click="confirmOrder(tr.id)" class="flex items-center">
                      <span>Confirm</span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="tr.status === 0">
                    <div @click="cancelOrder(tr.id)" class="flex items-center">
                      <span>Cancel</span>
                    </div>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <br />
      <template>
        <vs-pagination :total="20" v-model="page" :max="10"></vs-pagination>
      </template>
      <template>
        <div class="demo-alignment">
          <vs-popup
            fullscreen
            title="Detail Shipment"
            :active.sync="popupActive"
          >
            <div
              class="vx-col w-full"
              v-for="product in popUpData.products"
              :key="product.id"
            >
              <div class="vx-row margin-custom">
                <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base md:mt-0">
                  <h3 class="text-black">Product</h3>

                  <table>
                    <tr>
                      <td>Name</td>
                      <td>: {{ product.name }}</td>
                    </tr>
                    <tr>
                      <td>Price</td>
                      <td>: {{ product.price }}</td>
                    </tr>
                    <tr>
                      <td>Quantity</td>
                      <td>: {{ product.total }}</td>
                    </tr>
                    <tr>
                      <td>Color</td>
                      <td>: {{ product.color }}</td>
                    </tr>
                    <tr>
                      <td>Size</td>
                      <td>: {{ product.size }}</td>
                    </tr>
                    <tr>
                      <td>Note</td>
                      <td>: {{ product.note }}</td>
                    </tr>
                  </table>
                </div>
                <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base md:mt-0">
                  <img
                    v-bind:src="product.photo"
                    alt=""
                    class="rounded"
                    width="200"
                  />
                </div>
              </div>
            </div>
            <div
              class="vx-col w-full"
              v-for="shipment in popUpData.shipments"
              :key="shipment.id"
            >
              <div class="vx-row margin-custom">
                <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base md:mt-0">
                  <h3 class="text-black">Courier</h3>

                  <table>
                    <tr>
                      <td>Receipt Number</td>
                      <td>: {{ shipment.receipt_number }}</td>
                    </tr>
                    <tr>
                      <td>Price</td>
                      <td>: {{ shipment.price }}</td>
                    </tr>
                    <tr>
                      <td>Weight</td>
                      <td>: {{ shipment.weight }}</td>
                    </tr>
                    <tr>
                      <td>Note</td>
                      <td>: {{ shipment.note }}</td>
                    </tr>
                    <tr>
                      <td>Delivery Date</td>
                      <td>: {{ shipment.delivery_date }}</td>
                    </tr>
                    <tr>
                      <td>Receive Date</td>
                      <td>: {{ shipment.received_date }}</td>
                    </tr>
                    <tr>
                      <td>Courier Name</td>
                      <td>: {{ shipment.courier.name }}</td>
                    </tr>
                    <tr>
                      <td>Courier Service</td>
                      <td>: {{ shipment.courier.service }}</td>
                    </tr>
                    <tr>
                      <td>Courier Price</td>
                      <td>: {{ shipment.courier.value }}</td>
                    </tr>
                    <tr>
                      <td>Estimated</td>
                      <td>: {{ shipment.courier.etd }}</td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>: {{ setStatus(shipment.status) }}</td>
                    </tr>
                  </table>
                </div>
                <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base md:mt-0">
                  <h3 class="text-black">Address</h3>

                  <table>
                    <tr>
                      <td>Province</td>
                      <td>: {{ shipment.address.province_name }}</td>
                    </tr>
                    <tr>
                      <td>City</td>
                      <td>: {{ shipment.address.city_name }}</td>
                    </tr>
                    <tr>
                      <td>District</td>
                      <td>: {{ shipment.address.district_name }}</td>
                    </tr>
                    <tr>
                      <td>Pos Code</td>
                      <td>: {{ shipment.address.zip_code }}</td>
                    </tr>
                    <tr>
                      <td>Detail</td>
                      <td>: {{ shipment.address.detail }}</td>
                    </tr>
                    <tr>
                      <td>Receiver Name</td>
                      <td>: {{ shipment.address.receiver_name }}</td>
                    </tr>
                    <tr>
                      <td>Receiver Phone</td>
                      <td>: {{ shipment.address.receiver_phone }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </vs-popup>
        </div>
      </template>
    </div>
  </vx-card>
</template>
   

<script>
import axios from '../../../axios'
import Prism from 'vue-prism-component'
import moment from 'moment'
import router from '../../../router'
export default {
  data() {
    return {
      'selected': [],
      'tableList': [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      'payments': [],
      'orders': [],
      'colorAlert': 'primary',
      'titleAlert': 'Alert',
      'activeAlert': false,
      'valueInput': '',
      userAuth: this.$store.state.user,
      'deleteId': null,
      popupActive: false,
      popUpData: [],

      page: 1,
      limit: 10,
      oldData: [],
      active1: true,
      alert_success: false,
      message_success: '',
      color: 'success'

    }
  },
  watch: {
    page(newValue, oldValue) {
      this.getOrder()

    },


  },
  mounted() {
    this.popupActive = false
    this.getOrder()

  },
  methods: {
    setPopUp(tr) {

      this.popupActive = true
      this.popUpData = tr
      console.log(this.popUpData)

    },

    verifyOrder(id) {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#account-manage-buttons",
        scale: 0.45
      })
      axios.put('ecommerce/web/transaction/verify/' + id, {})
        .then(res => {

          console.log(res)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('success', 'Congrats', 'Success verify order ')
          this.getOrder()
        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('warning', 'Sorry', 'Something wrong')
        })


    },
    unverifyOrder(id) {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#account-manage-buttons",
        scale: 0.45
      })
      axios.put('ecommerce/web/transaction/unverify/' + id, {})
        .then(res => {

          console.log(res)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('success', 'Congrats', 'Success unverify order ')
          this.getOrder()
        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('warning', 'Sorry', 'Something wrong')
        })


    },

    confirmOrder(id) {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#account-manage-buttons",
        scale: 0.45
      })
      axios.put('ecommerce/web/order/confirm/' + id, {})
        .then(res => {

          console.log(res)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('success', 'Congrats', 'Success verify order ')
          this.getOrder()
        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('warning', 'Sorry', 'Something wrong')
        })


    },

    cancelOrder(id) {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#account-manage-buttons",
        scale: 0.45
      })
      axios.put('ecommerce/web/order/cancel/' + id, {})
        .then(res => {

          console.log(res)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('success', 'Congrats', 'Success verify order ')
          this.getOrder()
        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('warning', 'Sorry', 'Something wrong')
        })


    },

    changeStatus(status) {
      if (status == 0) {
        return 'New'
      }
      if (status == 1) {
        return 'Waiting'
      }
      if (status == 2) {
        return 'Sending'
      }
      if (status == 3) {
        return 'Received'
      }
      if (status == 4) {
        return 'Confirmed'
      }
      if (status == 9) {
        return 'Canceled'
      }

    },
    getOrder() {
      this.orders = []

      axios.get(`/ecommerce/web/order?limit=` + this.limit + '&page=' + this.page, {})
        .then(res => {

          console.log(res)
          this.orders = res.data




        })
        .catch(error => {
          console.log(error.response)

        })

    },
    setStatus(status) {
      if (status == 0) {
        return 'New'
      }
      if (status == 1) {
        return 'Waiting'
      }
      if (status == 2) {
        return 'Unverified'
      }
      if (status == 3) {
        return 'Verified'
      }
      if (status == 4) {
        return 'Completed'
      }
      if (status == 9) {
        return 'Canceled'
      }

    },

    format_date(value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    limitChar(str) {
      var output = ''
      if (str.length > 100) {
        str = str.substring(0, 100)
        output = str + '...'
      } else {
        output = str
      }
      return output
    },



    handleSelected(tr) {
      this.$router.push(`/payment/${tr.id}/applicant`)
    },
    acceptAlert(color, title, message) {

      this.$vs.notify({
        color,
        title,
        text: message
      })

    },

  },
  components: {
    Prism
  }
}
</script>
